import con from "../../../../../../connection";

const path = '/download';
export type GetAdminLogRequestParam = {
  /** 抽出開始日 */
  extract_date_start: string,
  /** 抽出終了日 */
  extract_date_end: string,
  /** ISPユーザー */
  user_id: string,
}

const download = (url: string) => () => ({
  getAdmin: (param: GetAdminLogRequestParam) => con.getFile<Blob>(`${url}${path}`, param),
});

export default download;
